var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 84,
    viewBox: "0 0 82 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7502 0L4.5 66.25L45.7167 29.1897C48.3006 26.8643 50.0076 23.7222 50.5521 20.289C51.0966 16.8558 50.4456 13.3397 48.708 10.329L42.7502 0Z",
    fill: "url(#paint0_linear_405_905)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7079 10.3285L46.1587 5.91602L18.7002 53.483L45.7166 29.1892C48.3005 26.8639 50.0075 23.7218 50.552 20.2886C51.0965 16.8553 50.4455 13.3392 48.7079 10.3285Z",
    fill: "url(#paint1_linear_405_905)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0376 19.5548L42.7501 0L38.8664 6.72209C47.5758 21.0959 39.672 41.9934 34.1812 48.7073L51.947 32.7304C53.753 31.1066 54.9462 28.9116 55.3268 26.513C55.7073 24.1144 55.2522 21.6579 54.0376 19.5548Z",
    fill: "url(#paint2_linear_405_905)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.038 19.5548L42.7505 0L51.6003 20.2448C54.8726 29.4458 47.4357 35.2837 45.5269 38.5105L51.9474 32.7263C53.7524 31.1028 54.945 28.9085 55.3255 26.5108C55.7061 24.1131 55.2515 21.6574 54.038 19.5548Z",
    fill: "url(#paint3_linear_405_905)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.005 42.8981C52.3174 41.7196 53.8763 40.849 55.5681 40.3498C57.2598 39.8505 59.0417 39.7353 60.7836 40.0124C62.5256 40.2895 64.1837 40.9521 65.637 41.9517C67.0903 42.9512 68.3021 44.2627 69.184 45.7903L80.9962 66.2581C75.1582 56.144 46.5594 46.9099 38.854 53.8262L51.005 42.8981Z",
    fill: "url(#paint4_linear_405_905)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9962 66.2499C68.0147 43.7616 51.8933 42.1007 38.854 53.8179L52.1329 41.8694C53.3064 40.8145 54.7006 40.0351 56.2138 39.5879C57.727 39.1407 59.321 39.037 60.8794 39.2845C62.4377 39.5319 63.9212 40.1242 65.2214 41.0182C66.5216 41.9121 67.6058 43.0852 68.3948 44.4516L80.9962 66.2499Z",
    fill: "url(#paint5_linear_405_905)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.242 47.257L79.571 63.804L68.4157 44.4516C67.6267 43.0852 66.5425 41.9121 65.2422 41.0182C63.942 40.1242 62.4586 39.5319 60.9002 39.2845C59.3418 39.037 57.7479 39.1407 56.2347 39.5879C54.7215 40.0351 53.3273 40.8145 52.1538 41.8694L39.0029 53.7105C40.137 52.6945 41.3304 51.7467 42.5768 50.8721L50.7738 44.3277C52.1057 43.1281 53.6888 42.2414 55.4074 41.7324C57.1259 41.2235 58.9366 41.105 60.7068 41.3858C62.4771 41.6666 64.1622 42.3395 65.639 43.3553C67.1157 44.3711 68.3467 45.7042 69.242 47.257Z",
    fill: "url(#paint6_linear_405_905)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9159 53.7767L38.8706 53.8179L38.9448 53.752L38.9159 53.7767Z",
    fill: "url(#paint7_linear_405_905)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7324 62.5898C79.4968 63.7426 80.2528 64.9572 80.9965 66.2504L79.629 63.8748C79.3274 63.4368 79.0299 63.0113 78.7324 62.5898Z",
    fill: "url(#paint8_linear_405_905)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62272 79.6776H4.09536L3.3696 81.8203H0.27648L4.6656 69.6898H8.08704L12.4762 81.8203H9.34848L8.62272 79.6776ZM7.8624 77.3966L6.35904 72.9557L4.87296 77.3966H7.8624ZM17.7345 81.9586C16.8936 81.9586 16.1448 81.8146 15.4881 81.5266C14.8315 81.2386 14.3131 80.8469 13.9329 80.3515C13.5528 79.8446 13.3397 79.2802 13.2936 78.6581H16.2139C16.2485 78.9922 16.404 79.2629 16.6805 79.4702C16.9569 79.6776 17.2968 79.7813 17.7 79.7813C18.0686 79.7813 18.3509 79.7122 18.5467 79.5739C18.7541 79.4242 18.8577 79.2341 18.8577 79.0037C18.8577 78.7272 18.7137 78.5256 18.4257 78.3989C18.1377 78.2606 17.6712 78.1109 17.0261 77.9496C16.3349 77.7883 15.7589 77.6213 15.2981 77.4485C14.8373 77.2642 14.4398 76.9819 14.1057 76.6018C13.7717 76.2101 13.6046 75.6859 13.6046 75.0293C13.6046 74.4763 13.7544 73.9752 14.0539 73.5259C14.3649 73.0651 14.8142 72.7022 15.4017 72.4373C16.0008 72.1723 16.7093 72.0398 17.5272 72.0398C18.7368 72.0398 19.6872 72.3394 20.3784 72.9384C21.0811 73.5374 21.4843 74.3323 21.588 75.323H18.8577C18.8117 74.989 18.6619 74.724 18.4085 74.5282C18.1665 74.3323 17.844 74.2344 17.4408 74.2344C17.0952 74.2344 16.8302 74.3035 16.6459 74.4418C16.4616 74.5685 16.3694 74.747 16.3694 74.9774C16.3694 75.2539 16.5134 75.4613 16.8014 75.5995C17.1009 75.7378 17.5617 75.876 18.1838 76.0142C18.8981 76.1986 19.4798 76.3829 19.9291 76.5672C20.3784 76.74 20.7701 77.028 21.1041 77.4312C21.4497 77.8229 21.6283 78.3528 21.6398 79.021C21.6398 79.5854 21.4785 80.0923 21.156 80.5416C20.8449 80.9794 20.3899 81.325 19.7909 81.5784C19.2033 81.8318 18.5179 81.9586 17.7345 81.9586ZM27.3702 81.9586C26.5292 81.9586 25.7804 81.8146 25.1238 81.5266C24.4671 81.2386 23.9487 80.8469 23.5686 80.3515C23.1884 79.8446 22.9753 79.2802 22.9292 78.6581H25.8495C25.8841 78.9922 26.0396 79.2629 26.3161 79.4702C26.5926 79.6776 26.9324 79.7813 27.3356 79.7813C27.7043 79.7813 27.9865 79.7122 28.1823 79.5739C28.3897 79.4242 28.4934 79.2341 28.4934 79.0037C28.4934 78.7272 28.3494 78.5256 28.0614 78.3989C27.7734 78.2606 27.3068 78.1109 26.6617 77.9496C25.9705 77.7883 25.3945 77.6213 24.9337 77.4485C24.4729 77.2642 24.0755 76.9819 23.7414 76.6018C23.4073 76.2101 23.2403 75.6859 23.2403 75.0293C23.2403 74.4763 23.39 73.9752 23.6895 73.5259C24.0006 73.0651 24.4499 72.7022 25.0374 72.4373C25.6364 72.1723 26.3449 72.0398 27.1628 72.0398C28.3724 72.0398 29.3228 72.3394 30.014 72.9384C30.7167 73.5374 31.1199 74.3323 31.2236 75.323H28.4934C28.4473 74.989 28.2975 74.724 28.0441 74.5282C27.8022 74.3323 27.4796 74.2344 27.0764 74.2344C26.7308 74.2344 26.4659 74.3035 26.2815 74.4418C26.0972 74.5685 26.0051 74.747 26.0051 74.9774C26.0051 75.2539 26.1491 75.4613 26.4371 75.5995C26.7366 75.7378 27.1974 75.876 27.8195 76.0142C28.5337 76.1986 29.1155 76.3829 29.5647 76.5672C30.014 76.74 30.4057 77.028 30.7398 77.4312C31.0854 77.8229 31.2639 78.3528 31.2755 79.021C31.2755 79.5854 31.1142 80.0923 30.7916 80.5416C30.4806 80.9794 30.0255 81.325 29.4265 81.5784C28.839 81.8318 28.1535 81.9586 27.3702 81.9586ZM42.1725 76.8437C42.1725 77.1202 42.1552 77.4082 42.1207 77.7077H35.4333C35.4794 78.3067 35.6695 78.7675 36.0036 79.0901C36.3492 79.4011 36.7696 79.5566 37.265 79.5566C38.0023 79.5566 38.5149 79.2456 38.8029 78.6235H41.9479C41.7866 79.2571 41.4928 79.8274 41.0666 80.3342C40.6519 80.8411 40.1277 81.2386 39.4941 81.5266C38.8605 81.8146 38.152 81.9586 37.3687 81.9586C36.424 81.9586 35.5831 81.757 34.8458 81.3538C34.1085 80.9506 33.5325 80.3746 33.1178 79.6258C32.7031 78.877 32.4957 78.0014 32.4957 76.9992C32.4957 75.997 32.6973 75.1214 33.1005 74.3726C33.5152 73.6238 34.0912 73.0478 34.8285 72.6446C35.5658 72.2414 36.4125 72.0398 37.3687 72.0398C38.3018 72.0398 39.1312 72.2357 39.857 72.6274C40.5828 73.019 41.1472 73.5778 41.5504 74.3035C41.9652 75.0293 42.1725 75.876 42.1725 76.8437ZM39.1485 76.0661C39.1485 75.5592 38.9757 75.156 38.6301 74.8565C38.2845 74.557 37.8525 74.4072 37.3341 74.4072C36.8388 74.4072 36.4183 74.5512 36.0727 74.8392C35.7386 75.1272 35.5312 75.5362 35.4506 76.0661H39.1485ZM49.1054 79.3147V81.8203H47.6021C46.5307 81.8203 45.6955 81.5611 45.0965 81.0427C44.4974 80.5128 44.1979 79.6546 44.1979 78.468V74.6318H43.0229V72.1781H44.1979V69.828H47.1528V72.1781H49.0882V74.6318H47.1528V78.5026C47.1528 78.7906 47.2219 78.9979 47.3602 79.1246C47.4984 79.2514 47.7288 79.3147 48.0514 79.3147H49.1054ZM58.0608 78.9518H52.5658L51.5117 81.8203H50.233L54.6394 69.8971H56.0045L60.3936 81.8203H59.1149L58.0608 78.9518ZM57.6979 77.9496L55.3133 71.4178L52.9286 77.9496H57.6979ZM61.7819 77.1029C61.7819 76.1237 61.9778 75.2712 62.3695 74.5454C62.7611 73.8082 63.3026 73.2437 63.9938 72.852C64.685 72.4488 65.4741 72.2472 66.3611 72.2472C67.5247 72.2472 68.4808 72.5352 69.2296 73.1112C69.9899 73.6872 70.4795 74.4706 70.6984 75.4613H69.4024C69.2411 74.7816 68.8898 74.2517 68.3483 73.8715C67.8184 73.4798 67.156 73.284 66.3611 73.284C65.7275 73.284 65.1573 73.428 64.6504 73.716C64.1435 74.004 63.7403 74.436 63.4408 75.012C63.1528 75.5765 63.0088 76.2734 63.0088 77.1029C63.0088 77.9323 63.1528 78.635 63.4408 79.211C63.7403 79.787 64.1435 80.219 64.6504 80.507C65.1573 80.795 65.7275 80.939 66.3611 80.939C67.156 80.939 67.8184 80.749 68.3483 80.3688C68.8898 79.9771 69.2411 79.4357 69.4024 78.7445H70.6984C70.4795 79.7122 69.9899 80.4898 69.2296 81.0773C68.4693 81.6648 67.5131 81.9586 66.3611 81.9586C65.4741 81.9586 64.685 81.7627 63.9938 81.371C63.3026 80.9678 62.7611 80.4034 62.3695 79.6776C61.9778 78.9403 61.7819 78.0821 61.7819 77.1029ZM81.4687 76.619C81.4687 77.0338 81.4572 77.3506 81.4342 77.5694H73.6063C73.6409 78.2837 73.8137 78.8942 74.1247 79.4011C74.4358 79.908 74.8447 80.2939 75.3516 80.5589C75.8585 80.8123 76.4114 80.939 77.0105 80.939C77.7938 80.939 78.4505 80.749 78.9804 80.3688C79.5218 79.9886 79.879 79.476 80.0518 78.8309H81.3305C81.1001 79.7525 80.6047 80.507 79.8444 81.0946C79.0956 81.6706 78.151 81.9586 77.0105 81.9586C76.1234 81.9586 75.3286 81.7627 74.6258 81.371C73.9231 80.9678 73.3702 80.4034 72.967 79.6776C72.5753 78.9403 72.3794 78.0821 72.3794 77.1029C72.3794 76.1237 72.5753 75.2654 72.967 74.5282C73.3586 73.7909 73.9058 73.2264 74.6086 72.8347C75.3113 72.443 76.1119 72.2472 77.0105 72.2472C77.909 72.2472 78.6924 72.443 79.3606 72.8347C80.0402 73.2264 80.5586 73.7563 80.9158 74.4245C81.2844 75.0811 81.4687 75.8126 81.4687 76.619ZM80.2418 76.5845C80.2534 75.8818 80.1094 75.2827 79.8098 74.7874C79.5218 74.292 79.1244 73.9176 78.6175 73.6642C78.1106 73.4107 77.5577 73.284 76.9586 73.284C76.0601 73.284 75.294 73.572 74.6604 74.148C74.0268 74.724 73.6754 75.5362 73.6063 76.5845H80.2418Z",
    fill: "url(#paint9_linear_405_905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_405_905",
    x1: 44.9524,
    y1: 13.8656,
    x2: 16.118,
    y2: 51.0457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23324F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#295061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#317678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#368D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38968B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_405_905",
    x1: 44.0186,
    y1: 20.3972,
    x2: 14.6182,
    y2: 60.0439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23324F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#284B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#368C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38968B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_405_905",
    x1: 30.8718,
    y1: 2.02448,
    x2: 43.6425,
    y2: 32.8833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2A6078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3F868A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4C9D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51A699"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_405_905",
    x1: 37.6397,
    y1: -0.425553,
    x2: 48.857,
    y2: 26.6694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51BBAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_405_905",
    x1: 62.4454,
    y1: 45.3812,
    x2: 56.6281,
    y2: 79.2726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23324F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#295061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#317678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#368D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38968B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_405_905",
    x1: 42.5724,
    y1: 40.2952,
    x2: 63.0568,
    y2: 55.6606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2A6078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3F868A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4C9D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51A699"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_405_905",
    x1: 69.2255,
    y1: 66.0763,
    x2: 47.9809,
    y2: 42.5552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51BBAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_405_905",
    x1: 38.8706,
    y1: 53.7849,
    x2: 38.9448,
    y2: 53.7849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F2BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD71FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_405_905",
    x1: 78.7324,
    y1: 64.4201,
    x2: 80.9965,
    y2: 64.4201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F2BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD71FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_405_905",
    x1: -4.17724,
    y1: 76.9463,
    x2: 81.3714,
    y2: 78.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5FCFD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.23fd1c26495a0993d58073dab3722f20.svg";
export { ForwardRef as ReactComponent };